import { render } from "./ItemsAdjustmentModal.vue?vue&type=template&id=03822943&scoped=true"
import script from "./ItemsAdjustmentModal.vue?vue&type=script&lang=js"
export * from "./ItemsAdjustmentModal.vue?vue&type=script&lang=js"

import "./ItemsAdjustmentModal.vue?vue&type=style&index=0&id=03822943&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03822943"]])

export default __exports__